'use strict';Object.defineProperty(exports,"__esModule",{value:true});function noop(){}
var defaultProps=exports.defaultProps={
prefixCls:'am-search',
placeholder:'',
onSubmit:noop,
onChange:noop,
onFocus:noop,
onBlur:noop,
onClear:noop,
showCancelButton:false,
cancelText:'取消',
disabled:false};


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/search-bar/PropsType.js
// module id = 303
// module chunks = 0